import React, { useEffect, useRef } from 'react';
import './PresenceMap.css';

// All showroom / dealer locations. Adding a new city later is just one
// more object in this array — nothing else needs to change.
const LOCATIONS = [
  { lat: 21.1702, lng: 72.8311, name: 'Surat' },
  { lat: 23.0225, lng: 72.5714, name: 'Ahmedabad' },
  { lat: 22.3039, lng: 70.8022, name: 'Rajkot' },
  { lat: 19.0760, lng: 72.8777, name: 'Mumbai' },
  { lat: 12.9716, lng: 77.5946, name: 'Bengaluru' },
  { lat: 21.0077, lng: 75.5626, name: 'Jalgaon' },
  { lat: 22.5726, lng: 88.3639, name: 'Kolkata' },
  { lat: 18.5204, lng: 73.8567, name: 'Pune' },
  { lat: 28.7041, lng: 77.1025, name: 'Delhi' },
  { lat: 22.4707, lng: 70.0577, name: 'Jamnagar' },
  { lat: 16.7050, lng: 74.2433, name: 'Kolhapur' },
  { lat: 34.083656, lng: 74.797371, name: 'Srinagar' },
  { lat: 11.2194, lng: 78.1677, name: 'Namakkal' },
  { lat: 19.2403, lng: 73.1305, name: 'Kalyan' },
  { lat: 27.17667, lng: 78.008072, name: 'Agra' },
  { lat: 9.151239, lng: 76.730766, name: 'Adoor' },
  { lat: 20.937424, lng: 77.779549, name: 'Amravati' },
  { lat: 19.101053, lng: 74.740677, name: 'Ahmednagar' },
  { lat: 26.449896, lng: 74.639915, name: 'Ajmer' },
  { lat: 20.707228, lng: 77.00296, name: 'Akola' },
  { lat: 27.560932, lng: 76.625015, name: 'Alwar' },
  { lat: 23.116444, lng: 83.196121, name: 'Ambikapur' },
  { lat: 31.63398, lng: 74.872261, name: 'Amritsar' },
  { lat: 22.555426, lng: 72.951439, name: 'Anand' },
  { lat: 14.685564, lng: 77.595406, name: 'Ananthapur' },
  { lat: 21.617355, lng: 72.997627, name: 'Ankleshwar' },
  { lat: 23.673944, lng: 86.952393, name: 'Asansol' },
  { lat: 19.901054, lng: 75.352478, name: 'Aurangabad' },
  { lat: 24.75, lng: 84.370003, name: 'Aurangabad (Bihar)' },
  { lat: 19.166784, lng: 73.236794, name: 'Badalpur' },
  { lat: 16.1725, lng: 75.6557, name: 'Bagalkot' },
  { lat: 21.138327, lng: 73.09539, name: 'Baradoli' },
  { lat: 28.375694, lng: 79.435959, name: 'Bareilly' },
  { lat: 30.210995, lng: 74.945473, name: 'Bathinda' },
  { lat: 26.100735, lng: 74.319077, name: 'Beawar' },
  { lat: 18.992012, lng: 75.776138, name: 'Beed' },
  { lat: 15.850367, lng: 74.504662, name: 'Belgaum' },
  { lat: 25.253391, lng: 86.989059, name: 'Bhagalpur' },
  { lat: 21.705723, lng: 72.998199, name: 'Bharuch' },
  { lat: 21.7645, lng: 72.1519, name: 'Bhavnagar' },
  { lat: 21.195434, lng: 81.967146, name: 'Bhilai' },
  { lat: 25.346251, lng: 74.636383, name: 'Bhilwara' },
  { lat: 16.544893, lng: 81.52124, name: 'Bhimavaram' },
  { lat: 28.2088, lng: 76.8446, name: 'Bhiwadi' },
  { lat: 23.259933, lng: 77.412613, name: 'Bhopal' },
  { lat: 20.296059, lng: 85.824539, name: 'Bhubaneshwar' },
  { lat: 23.242001, lng: 69.666931, name: 'Bhuj' },
  { lat: 21.0133461, lng: 75.77745, name: 'Bhusawal' },
  { lat: 25.9268, lng: 74.6506, name: 'Bijainagar' },
  { lat: 28.027138, lng: 73.302155, name: 'Bikaner' },
  { lat: 22.078642, lng: 82.152328, name: 'Bilaspur' },
  { lat: 20.769026, lng: 72.977776, name: 'Bilimora' },
  { lat: 24.696135, lng: 84.986954, name: 'Bodh Gaya' },
  { lat: 11.258753, lng: 75.780411, name: 'Calicut' },
  { lat: 20.4613641, lng: 74.9898334, name: 'Chalisgaon' },
  { lat: 30.741482, lng: 76.768066, name: 'Chandigarh' },
  { lat: 9.4519851, lng: 76.5367065, name: 'Changanacherry' },
  { lat: 13.067439, lng: 80.237617, name: 'Chennai' },
  { lat: 13.31232, lng: 75.770889, name: 'Chikmagalur' },
  { lat: 17.53231, lng: 73.517792, name: 'Chiplun' },
  { lat: 9.931233, lng: 76.267303, name: 'Cochin' },
  { lat: 11.0168, lng: 76.9558, name: 'Coimbatore' },
  { lat: 20.462521, lng: 85.882988, name: 'Cuttack' },
  { lat: 22.8379, lng: 74.2531, name: 'Dahod' },
  { lat: 26.152973, lng: 85.901413, name: 'Darbhanga' },
  { lat: 14.4647312, lng: 75.9233243, name: 'Davangere' },
  { lat: 24.258503, lng: 72.190674, name: 'Deesa' },
  { lat: 30.321915, lng: 78.026619, name: 'Dehradun' },
  { lat: 23.795399, lng: 86.427040, name: 'Dhanbad' },
  { lat: 20.903118, lng: 74.774986, name: 'Dhule' },
  { lat: 27.472834, lng: 94.911964, name: 'Dibrugarh' },
  { lat: 21.324507, lng: 74.556389, name: 'Dondaicha' },
  { lat: 24.20122, lng: 87.62048, name: 'Dumka' },
  { lat: 21.1870039, lng: 81.2825047, name: 'Durg' },
  { lat: 23.53344, lng: 87.32193, name: 'Durgapur' },
  { lat: 9.9920905, lng: 76.2864593, name: 'Ernakulam' },
  { lat: 11.342423, lng: 77.728165, name: 'Erode' },
  { lat: 15.42879, lng: 75.631269, name: 'Gadag' },
  { lat: 23.0791, lng: 70.140152, name: 'Gandhidham' },
  { lat: 23.233086, lng: 72.651634, name: 'Gandhinagar' },
  { lat: 28.667856, lng: 77.449791, name: 'Ghaziabad' },
  { lat: 15.496777, lng: 73.827827, name: 'Goa' },
  { lat: 22.7651559, lng: 73.6093769, name: 'Godhra' },
  { lat: 21.961946, lng: 70.792297, name: 'Gondal' },
  { lat: 26.765844, lng: 83.364944, name: 'Gorakhpur' },
  { lat: 16.314209, lng: 80.435028, name: 'Guntur' },
  { lat: 28.457523, lng: 77.026344, name: 'Gurgaon' },
  { lat: 10.595821, lng: 76.032944, name: 'Guruvayoor' },
  { lat: 26.148043, lng: 91.731377, name: 'Guwahati' },
  { lat: 26.218287, lng: 78.182831, name: 'Gwalior' },
  { lat: 29.2183, lng: 79.5130, name: 'Haldwani' },
  { lat: 29.625996, lng: 74.287491, name: 'Hanumangarh' },
  { lat: 29.94569, lng: 78.164246, name: 'Haridwar' },
  { lat: 23.5932506, lng: 72.971911, name: 'Himatnagar' },
  { lat: 29.151861, lng: 75.721123, name: 'Hisar' },
  { lat: 15.2689, lng: 76.3909, name: 'Hospet' },
  { lat: 15.371598, lng: 75.101166, name: 'Hubli' },
  { lat: 17.387140, lng: 78.491684, name: 'Hyderabad' },
  { lat: 16.709002, lng: 74.456078, name: 'Ichalkaranji' },
  { lat: 22.719568, lng: 75.857727, name: 'Indore' },
  { lat: 23.16877, lng: 79.931847, name: 'Jabalpur' },
  { lat: 19.07, lng: 82.029999, name: 'Jagdalpur' },
  { lat: 26.92207, lng: 75.778885, name: 'Jaipur' },
  { lat: 26.889175, lng: 70.867766, name: 'Jaisalmer' },
  { lat: 31.326015, lng: 75.57618, name: 'Jalandhar' },
  { lat: 19.830005, lng: 75.879995, name: 'Jalna' },
  { lat: 34.083656, lng: 74.797371, name: 'Jammu' },
  { lat: 22.8046, lng: 86.2029, name: 'Jamshedpur' },
  { lat: 25.436298, lng: 78.567352, name: 'Jhansi' },
  { lat: 26.263863, lng: 73.008957, name: 'Jodhpur' },
  { lat: 21.515471, lng: 70.456444, name: 'Junagadh' },
  { lat: 17.320486, lng: 76.839752, name: 'Kalaburagi' },
  { lat: 22.606001, lng: 73.462997, name: 'Kalol' },
  { lat: 11.874477, lng: 75.370369, name: 'Kannur' },
  { lat: 26.449923, lng: 80.331871, name: 'Kanpur' },
  { lat: 31.379999, lng: 75.379997, name: 'Kapurthala' },
  { lat: 17.287505, lng: 74.157496, name: 'Karad' },
  { lat: 18.438555, lng: 79.128838, name: 'Karimnagar' },
  { lat: 29.685629, lng: 76.990547, name: 'Karnal' },
  { lat: 23.833717, lng: 80.420609, name: 'Katni' },
  { lat: 20.711622, lng: 76.566132, name: 'Khamgaon' },
  { lat: 17.247253, lng: 80.151443, name: 'Khammam' },
  { lat: 22.34601, lng: 87.231972, name: 'Kharagpur' },
  { lat: 26.588528, lng: 74.872513, name: 'Kishangarh' },
  { lat: 8.8932, lng: 76.6141, name: 'Kollam' },
  { lat: 22.3516717, lng: 82.7458283, name: 'Korba' },
  { lat: 25.1695204, lng: 75.8539808, name: 'Kota' },
  { lat: 9.591441, lng: 76.522171, name: 'Kottayam' },
  { lat: 13.632182, lng: 74.690544, name: 'Kundapura' },
  { lat: 15.834536, lng: 78.029366, name: 'Kurnool' },
  { lat: 26.8467, lng: 80.9462, name: 'Lucknow' },
  { lat: 30.900965, lng: 75.857277, name: 'Ludhiana' },
  { lat: 16.737509, lng: 78.008125, name: 'Mahabubnagar' },
  { lat: 20.5549916, lng: 74.5344192, name: 'Malegaon' },
  { lat: 20.886482, lng: 76.21627, name: 'Malkapur' },
  { lat: 24.076836, lng: 75.069298, name: 'Mandsaur' },
  { lat: 12.9141507, lng: 74.8559478, name: 'Mangalore' },
  { lat: 15.286691, lng: 73.96978, name: 'Margao' },
  { lat: 27.492413, lng: 77.673676, name: 'Mathura' },
  { lat: 28.984644, lng: 77.705956, name: 'Meerut' },
  { lat: 23.586761, lng: 72.369949, name: 'Mehsana' },
  { lat: 23.470012, lng: 73.299988, name: 'Modasa' },
  { lat: 30.81646, lng: 75.171707, name: 'Moga' },
  { lat: 28.841064, lng: 78.795319, name: 'Moradabad' },
  { lat: 22.811989, lng: 70.823616, name: 'Morbi' },
  { lat: 29.471397, lng: 77.696732, name: 'Muzaffarnagar' },
  { lat: 26.121473, lng: 85.368752, name: 'Muzaffarpur' },
  { lat: 12.311827, lng: 76.652985, name: 'Mysore' },
  { lat: 22.700001, lng: 72.870003, name: 'Nadiad' },
  { lat: 26.3333393, lng: 92.6833273, name: 'Nagaon' },
  { lat: 8.17445, lng: 77.432159, name: 'Nagarcoil' },
  { lat: 21.146633, lng: 79.08886, name: 'Nagpur' },
  { lat: 19.169815, lng: 77.319717, name: 'Nanded' },
  { lat: 19.997454, lng: 73.789803, name: 'Nashik' },
  { lat: 24.9291, lng: 73.8213, name: 'Nathdwara' },
  { lat: 19.033, lng: 73.0297, name: 'Navi Mumbai' },
  { lat: 20.9227528, lng: 72.9088799, name: 'Navsari' },
  { lat: 24.465285, lng: 74.871128, name: 'Neemuch' },
  { lat: 14.442599, lng: 79.986458, name: 'Nellore' },
  { lat: 28.474388, lng: 77.50399, name: 'Noida' },
  { lat: 24.179331, lng: 72.426682, name: 'Palanpur' },
  { lat: 19.695768, lng: 72.763657, name: 'Palghar' },
  { lat: 25.771315, lng: 73.323685, name: 'Pali' },
  { lat: 30.695202, lng: 76.854172, name: 'Panchkulla' },
  { lat: 29.398928, lng: 76.977081, name: 'Panipat' },
  { lat: 19.25779, lng: 76.773743, name: 'Parbhani' },
  { lat: 9.264758, lng: 76.787041, name: 'Pathanamthitta' },
  { lat: 32.265942, lng: 75.646873, name: 'Pathankot' },
  { lat: 30.34, lng: 76.379997, name: 'Patiala' },
  { lat: 25.612677, lng: 85.158875, name: 'Patna' },
  { lat: 10.770388, lng: 76.37706, name: 'Pattambi' },
  { lat: 12.0328072, lng: 75.2684555, name: 'Payyanur' },
  { lat: 10.1319, lng: 76.4822, name: 'Perumbavoor' },
  { lat: 11.916064, lng: 79.812325, name: 'Pondicherry' },
  { lat: 21.640575, lng: 69.605965, name: 'Porbandar' },
  { lat: 11.2553885, lng: 75.7960016, name: 'Puthiyara' },
  { lat: 21.9, lng: 83.400002, name: 'Raigarh' },
  { lat: 21.2376284, lng: 81.5962147, name: 'Raipur' },
  { lat: 17.004393, lng: 81.783325, name: 'Rajahmundry' },
  { lat: 12.489392, lng: 78.567913, name: 'Rajapalayam' },
  { lat: 21.097855, lng: 81.033707, name: 'Rajnandgaon' },
  { lat: 23.344101, lng: 85.309563, name: 'Ranchi' },
  { lat: 23.334169, lng: 75.037636, name: 'Ratlam' },
  { lat: 17.2478, lng: 73.3709, name: 'Ratnagiri' },
  { lat: 24.530727, lng: 81.29911, name: 'Rewa' },
  { lat: 28.895515, lng: 76.606613, name: 'Rohtak' },
  { lat: 11.664325, lng: 78.146011, name: 'Salem' },
  { lat: 19.581099, lng: 74.205009, name: 'Sangamner' },
  { lat: 16.8508895, lng: 74.6106424, name: 'Sangli' },
  { lat: 24.953514, lng: 84.011787, name: 'Sasaram' },
  { lat: 17.6882042, lng: 74.035863, name: 'Satara' },
  { lat: 24.579716, lng: 80.832176, name: 'Satna' },
  { lat: 17.43993, lng: 78.498276, name: 'Secunderabad' },
  { lat: 13.92993, lng: 75.5681, name: 'Shivamogga' },
  { lat: 19.620296, lng: 74.654655, name: 'Shrirampur' },
  { lat: 27.63485, lng: 75.1725376, name: 'Sikar' },
  { lat: 26.732311, lng: 88.410286, name: 'Siliguri' },
  { lat: 9.453126, lng: 77.807236, name: 'Sivakasi' },
  { lat: 17.65992, lng: 75.906387, name: 'Solapur' },
  { lat: 29.903839, lng: 73.87719, name: 'Sri Ganganagar' },
  { lat: 22.7739, lng: 71.6673, name: 'Surendranagar' },
  { lat: 11.74805, lng: 75.48938, name: 'Thalassery' },
  { lat: 8.524139, lng: 76.936638, name: 'Thiruvananthapuram' },
  { lat: 9.897157, lng: 76.713409, name: 'Thodupuzha' },
  { lat: 10.530345, lng: 76.214729, name: 'Thrissur' },
  { lat: 10.7905, lng: 78.7047, name: 'Tiruchirapalli' },
  { lat: 8.741222, lng: 77.694626, name: 'Tirunelveli' },
  { lat: 13.338592, lng: 77.101208, name: 'Tumkur' },
  { lat: 24.57127, lng: 73.691544, name: 'Udaipur' },
  { lat: 23.1793, lng: 75.784912, name: 'Ujjain' },
  { lat: 19.2387176, lng: 73.1642274, name: 'Ulhasnagar' },
  { lat: 23.8077794, lng: 72.3952941, name: 'Unjha' },
  { lat: 22.310696, lng: 73.192635, name: 'Vadodara' },
  { lat: 22.5477, lng: 72.9251, name: 'Vallabh Vidhyanagar' },
  { lat: 20.6039609, lng: 72.9337587, name: 'Valsad' },
  { lat: 20.4950658, lng: 72.9017563, name: 'Vapi' },
  { lat: 25.321684, lng: 82.987289, name: 'Varanasi' },
  { lat: 19.366636, lng: 72.816101, name: 'Vasai' },
  { lat: 19.077065, lng: 72.998993, name: 'Vashi' },
  { lat: 12.934968, lng: 79.146881, name: 'Vellore' },
  { lat: 20.9114744, lng: 70.3709222, name: 'Veraval' },
  { lat: 23.524026, lng: 77.8059999, name: 'Vidisha' },
  { lat: 13.295583, lng: 77.800758, name: 'Vijayapur' },
  { lat: 16.515099, lng: 80.632095, name: 'Vijaywada' },
  { lat: 19.465622, lng: 72.806099, name: 'Virar' },
  { lat: 17.690474, lng: 83.231049, name: 'Vishakhapatnam' },
  { lat: 20.1, lng: 77.150002, name: 'Washim' },
  { lat: 20.388794, lng: 78.120407, name: 'Yavatmal' },
  { lat: 20.0431477, lng: 74.4826003, name: 'Yevla' },
];

const MAPBOX_TOKEN = 'pk.eyJ1IjoiaGFyc2hpdGE4NzQzIiwiYSI6ImNtdWh3cnRpejEwbXMyenNpNWdmaWZxbDIifQ.-kGM7E-fFZRCqH2OwJZgpw';

const MAPBOX_JS = 'https://api.mapbox.com/mapbox-gl-js/v3.1.2/mapbox-gl.js';
const MAPBOX_CSS = 'https://api.mapbox.com/mapbox-gl-js/v3.1.2/mapbox-gl.css';

function loadScript(src, id) {
  return new Promise((resolve, reject) => {
    if (document.getElementById(id)) return resolve();
    const script = document.createElement('script');
    script.id = id;
    script.src = src;
    script.async = true;
    script.onload = resolve;
    script.onerror = reject;
    document.body.appendChild(script);
  });
}
function loadStyle(href, id) {
  if (document.getElementById(id)) return;
  const link = document.createElement('link');
  link.id = id;
  link.rel = 'stylesheet';
  link.href = href;
  document.head.appendChild(link);
}

const PresenceMap = () => {
  const mapContainerRef = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    loadStyle(MAPBOX_CSS, 'mapbox-css');
    loadScript(MAPBOX_JS, 'mapbox-js').then(initMap);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function initMap() {
    if (!window.mapboxgl || !mapContainerRef.current) return;

    window.mapboxgl.accessToken = MAPBOX_TOKEN;

    const map = new window.mapboxgl.Map({
      container: mapContainerRef.current,
      style: 'mapbox://styles/mapbox/streets-v12',
      center: [78.9629, 22.5937], // roughly the centre of India
      zoom: 3.8,
      projection: 'mercator', // flat rectangular map, not the 3D globe
    });
    mapRef.current = map;

    map.on('load', () => {
      LOCATIONS.forEach((loc) => {
        const el = document.createElement('div');
        el.className = 'pmap-marker-red';
        el.innerHTML = `
          <svg width="18" height="25" viewBox="0 0 24 34" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 0C5.4 0 0 5.4 0 12c0 9 12 22 12 22s12-13 12-22c0-6.6-5.4-12-12-12z" fill="#ea4335"/>
            <circle cx="12" cy="12" r="5" fill="#ffffff"/>
          </svg>
        `;

        const popup = new window.mapboxgl.Popup({ offset: 14 }).setHTML(`<strong>${loc.name}</strong>`);

        new window.mapboxgl.Marker({ element: el, anchor: 'bottom' })
          .setLngLat([loc.lng, loc.lat])
          .setPopup(popup)
          .addTo(map);
      });
    });
  }

  return (
    <section className="Presence_PAGE">
      <div className="PresencePage_Container">
        <div className="Page-Main_Dec">
          <h1 className="Page-title_UpperCase">PRESENCE &amp; AVAILABILITY</h1>
          <p className="Page_Subtitle-Light">We are available across india. Find our Specialist Near you…</p>
        </div>

        <div className="PresenceMap">
          <div ref={mapContainerRef} style={{ width: '100%', height: '100%' }}></div>
        </div>
      </div>
    </section>
  );
};

export default PresenceMap;